import { gsap } from "gsap";
import { LayoutController } from "onearm";

/**
 * @class HUDAnimationsController
 * @description Controller for HUD transition animations between game modes
 */
export class HUDAnimationsController extends LayoutController {
    /**
     * @description Animate HUD to free spins mode
     * @returns {gsap.core.Timeline}
     */
    toFreeSpinsMode() {
        const tl = gsap.timeline();

        this.forAll("leftPanel", (c) => {
            c.originX = c.x;
            tl.to(c, {
                alpha: 0,
                x: -1000,
                duration: 2,
                ease: "power2.inOut",
            }, 0);
        });

        this.forAll("FeatureButtons", (c) => {
            tl.to(c, {
                alpha: 0,
                duration: 2,
                ease: "power2.inOut",
            }, 0);
        });

        this.forAll("right", (c) => {
            c.originX = c.x;
            tl.to(c, {
                x: 130,
                duration: 1.5,
                ease: "power2.inOut",
            }, 0);
        });

        return tl;
    }

    /**
     * @description Animate HUD back to main game mode
     * @returns {gsap.core.Timeline}
     */
    toMainGameMode() {
        const tl = gsap.timeline();

        this.forAll("leftPanel", (c) => {
            tl.to(c, {
                x: c.originX,
                alpha: 1,
                duration: 2,
                ease: "power2.inOut",
            }, 0);
        });

        this.forAll("FeatureButtons", (c) => {
            tl.to(c, {
                alpha: 1,
                duration: 2,
                ease: "power2.inOut",
            }, 0);
        });

        this.forAll("right", (c) => {
            tl.to(c, {
                x: c.originX,
                duration: 1.5,
                ease: "power2.inOut",
            }, 0);
        });

        return tl;
    }
}

